module.exports = __webpack_public_path__ + "static/media/bg_white.431a5a6b.png";